import { render, staticRenderFns } from "./FreeClinicPlat.vue?vue&type=template&id=6cf6b262&scoped=true"
import script from "./FreeClinicPlat.vue?vue&type=script&lang=js"
export * from "./FreeClinicPlat.vue?vue&type=script&lang=js"
import style0 from "./FreeClinicPlat.vue?vue&type=style&index=0&id=6cf6b262&prod&lang=scss&scoped=true"
import style1 from "./FreeClinicPlat.vue?vue&type=style&index=1&id=6cf6b262&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf6b262",
  null
  
)

export default component.exports